// =============================================================
// The watermark's repeating tile, as a CSS url().
//
// Pure -- no React, no DOM -- so it can be checked on its own.
//
// The tile holds the text twice, rotated, offset like brickwork so the
// rows do not line up into stripes. The second copy is set ACROSS the
// tile's left and right edges: when the tile repeats, the half cut off
// at one edge meets its other half from the next tile, so every copy on
// screen reads as one whole word.
// =============================================================

const XML_ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;',
};

const escapeXml = (value) => String(value).replace(/[&<>"']/g, (c) => XML_ENTITIES[c]);

const FONT_SIZE = 24;
const LETTER_SPACING = 4;
const ANGLE = -24;
// A data-URI SVG cannot load the page's web font, so it names system faces.
const FONT_FAMILY = 'Segoe UI, Arial, Helvetica, sans-serif';

/**
 * The tile for `text`, or null when there is nothing to draw -- an empty
 * or whitespace-only WATER_MARK turns the watermark off.
 */
export const buildWatermarkTile = (text) => {
  const label = String(text || '').trim();
  if (!label) return null;

  // Grows with the text, so a long name never runs into the next copy.
  const width = Math.max(420, Math.round(label.length * 19 + 200));
  const height = Math.round(width * 0.62);
  const safe = escapeXml(label);

  const copy = (x, y) =>
    `<text x="${x}" y="${y}" text-anchor="middle" dominant-baseline="middle"`
    + ` transform="rotate(${ANGLE} ${x} ${y})" font-family="${FONT_FAMILY}"`
    + ` font-size="${FONT_SIZE}" font-weight="700" letter-spacing="${LETTER_SPACING}">${safe}</text>`;

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">`
    + copy(width / 2, Math.round(height * 0.25))
    + copy(0, Math.round(height * 0.75))
    + copy(width, Math.round(height * 0.75))
    + '</svg>';

  return `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}")`;
};
